/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1797
 */

var r = require(/* 940 */"../../940")
module.exports = function (e, t) {
  for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = r(e));) {
    ;
  }
  return e
}
